import { createContext } from 'react';

const ApiClientContext = createContext(null);

export default ApiClientContext;
